/* Hero section image slider — infinite forward loop with dots */
(function () {
  'use strict';

  function initHeroSlider(root) {
    if (root.dataset.heroInitialized === 'true') return;

    var track = root.querySelector('[data-hero-slides]');
    var allSlides = root.querySelectorAll('[data-hero-slide]');
    var dots = root.querySelectorAll('[data-hero-dot]');
    var realCount = dots.length;

    if (!track) {
      console.warn('[hero-slider] No [data-hero-slides] track found — slider not initialized.');
      return;
    }
    if (allSlides.length < 2 || realCount < 2) {
      console.warn('[hero-slider] Need at least 2 Slide blocks with images. Found slides:', allSlides.length, 'dots:', realCount);
      return;
    }

    root.dataset.heroInitialized = 'true';

    var current = 0;
    var speed = parseFloat(root.getAttribute('data-autoplay-speed')) * 1000 || 5000;
    var timer = null;

    function setTransition(enabled) {
      track.style.transition = enabled ? 'transform 0.7s ease' : 'none';
    }

    function render() {
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      var dotIndex = current % realCount;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === dotIndex);
      });
    }

    function next() {
      current += 1;
      setTransition(true);
      render();

      if (current === realCount) {
        var onEnd = function () {
          track.removeEventListener('transitionend', onEnd);
          setTransition(false);
          current = 0;
          render();
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { setTransition(true); });
          });
        };
        track.addEventListener('transitionend', onEnd);
      }
    }

    function goTo(index) {
      current = index;
      setTransition(true);
      render();
    }

    function startAutoplay() {
      stopAutoplay();
      timer = setInterval(next, speed);
    }
    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-index'), 10));
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    window.addEventListener('resize', function () {
      setTransition(false);
      render();
    });

    setTransition(false);
    render();
    startAutoplay();

    console.log('[hero-slider] initialized with', realCount, 'slides');
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-hero-slider]');
    if (roots.length === 0) {
      console.warn('[hero-slider] No [data-hero-slider] element found on page.');
    }
    roots.forEach(initHeroSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  }
})();
